<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <footer class="footer-root">
        <div class="footer-content">
            <div>
                <h4>{{ content?.Section[0]?.label }}</h4>
                <Link
                    v-for="link in content?.Section[0]?.Links"
                    v-bind:key="link.id"
                    :label="link.label"
                    :id="link.url"
                    :action="updateLang"
                />
            </div>
            <div>
                <h4>{{ content?.Section[1]?.label }}</h4>
                <FooterMenu :section="content?.Section[1]" />
            </div>
            <div>
                <h4>{{ content?.Section[2]?.label }}</h4>
                <FooterMenu :section="content?.Section[2]" />
            </div>
            <div class="animate-underline">
                <h4>{{ content?.Section[3]?.label }}</h4>
                <Linkedin :url="content?.Section[3]?.Links[2]?.url" />
                <Instagram :url="content?.Section[3]?.Links[3]?.url" />
                <!-- <Youtube :url="content?.Section[3]?.Links[3]?.url" /> -->
            </div>
        </div>

        <Copyright
            :copyright="content?.copyright"
            :madeIn="content?.madeIn"
        />
    </footer>
</template>

<script>
import { getLanguage, setLanguage } from '@/helpers'

// import Logo from '@/components/Logos/Logo.vue'
import Copyright from '@/components/Text/Copyright.vue'
import FooterMenu from '@/components/Menus/Footer.vue'

// import Youtube from '@/components/Icons/Social/Youtube.vue'
import Linkedin from '@/components/Icons/Social/Linkedin.vue'
import Instagram from '@/components/Icons/Social/Instagram.vue'

import Link from '@/components/Links/Link.vue'

export default {
    name: 'FooterView',
    components: {
        // Logo,
        Copyright,
        FooterMenu,
        Linkedin,
        Instagram,
        Link
    },
    props: {
        content: Object
    },
    methods: {
        updateLang(e) {
            const currentLang = getLanguage('language')
            const lang = e.currentTarget.getAttribute('data-id')

            if (currentLang === lang) {
                return;
            }

            setLanguage(lang)
            location.reload();
        }
    }
}
</script>

<style lang="scss">
/* Semantic <footer> wrapper with no styling. full-width by default, no bg
   or padding, so each child (.footer-content + .copyright) controls its own
   full-width section independently. */
.footer-root {
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
    background: none;
}

.footer-content {
    display: flex;
    flex-wrap: wrap;
    padding: 80px 8vw;

    /* Vertical breathing room between the wrapped rows in the 2x2
       mobile/tablet layout (LANGUE/BZIOUP on top, LEGAL/SUIVEZ-NOUS
       below). Only applies while the sections wrap; on desktop
       ($mq-medium) all four sit in a single non-wrapping row, so
       this row-gap has no effect there. Column spacing stays handled
       by justify-content: space-between. */
    row-gap: 48px;

    /* Lift above the hero video (position: fixed, z-index: 1) so the h4
       titles and links paint over it instead of being hidden. */
    position: relative;
    z-index: 2;

    background-color: var(--bzioup-color-night);
    border-top: 1px solid rgba(218, 138, 139, 0.35);
    color: #fff;

    /* FooterMenu wraps its links in <ul> which has default top/bottom margin
       (~1em). That pushes the col 2 & 3 lists down vs col 1 (bare <a>'s).
       Reset it so all columns start at the same baseline below the h4. */
    ul {
        margin: 0;
        padding-left: 0;
    }
    justify-content: space-between;

    /* Section labels (LANGUE / BZIOUP / LEGAL / SUIVEZ NOUS).
       Brand pink so the column titles read as anchors against the
       dark footer bg, while the links below stay white. Same role
       the pink already plays on the rest of the site (price
       accents, pill, underlines). placed at top level so it beats
       any deeper override. */
    h4 {
        display: block;
        font-size: 14px;
        font-weight: 700;
        line-height: 1.3;
        margin: 0 0 14px 0;
        padding: 0;
        color: var(--bzioup-color-pink);
        text-transform: uppercase;
        letter-spacing: 0.6px;
    }

    >div {
        flex: 50%;
        text-align: left;

        a {
            margin-left: 0px;
            color: var(--bzioup-color-A);
            opacity: 1;
            transition: opacity 200ms ease-out;
        }

        a.link:hover,
        a.bold_link:hover {
            border: none;
            opacity: 1;
        }

        a.router-link-active {
            opacity: 1;
        }
    }


    >div:nth-child(1) {
        a {
            display: block;
        }
    }

    /* Social column: 2-column grid of icons. h4 spans both.
       Mobile-first it aligns LEFT to match the other three sections
       (which are text-align:left). The right-packing is a desktop-only
       choice (in the 4-across row the social column bookends the
       right edge), so it's applied in the $mq-medium block below.
       Left-aligning on mobile fixes the "follow us isn't aligned with
       the other sections" issue in the stacked 2-column layout. */
    >div:nth-child(4) {
        display: grid;
        grid-template-columns: max-content max-content;
        gap: 6px 8px;
        justify-content: start;
        justify-items: start;
        text-align: left;

        h4 {
            grid-column: 1 / -1;
            margin: 0 0 6px 0;
        }

        .social-icon {
            margin: 0;
            display: inline-block;
        }

        svg {
            width: 20px;
            height: 20px;
            fill: var(--bzioup-color-A);
        }
    }
}


@media (min-width: $mq-small) {
    .footer-content>div {
        flex: 50%;
    }
}

@media (min-width: $mq-medium) {
    .footer-content>div {
        flex: 25%;
    }

    /* Desktop: 4 columns in a single row. Pack the social column to
       the right edge so it bookends the row (the mobile/base styles
       keep it left-aligned with the other sections). */
    .footer-content>div:nth-child(4) {
        justify-content: end;
        justify-items: end;
        text-align: right;
    }
}

</style>
